import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { createWhatsappLink } from '../functions/create-whatsapp-link';

@Component({
  selector: 'app-whatsapp-button',
  imports: [],
  template: `
    <a
      class="bg-[#25d366] rounded-lg xl:rounded-full p-1 xl:p-3 fixed bottom-5 right-5 xl:bottom-10 xl:right-10 z-50"
      [href]="wppLink()"
    >
      <i class="bi bi-whatsapp text-3xl xl:text-5xl text-white"></i>
    </a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsappButton {
  message = input<string>('Oi, Code! Pode me ajudar?');

  wppLink = computed(() => createWhatsappLink(this.message()));
}
